<template>
    <button @click="addToFavorites" class="single-product-favorite-button">
        <img src="/images/icons/coeur-orange.png" alt="Coeur">
        <span v-if="isInFavorites">Retirer de mes coups de coeur</span>
        <span v-else>Ajouter à mes coups de coeur</span>
    </button>
</template>

<script>
  import store from './../store'

  export default {
    name: 'single-product-favorite',
    props: {
      productId: { type: Number, required: true }
    },
    data () {
      return { state: store.state }
    },
    computed: {
      isInFavorites () {
        return new Set(store.getFavoriteProducts()).has(this.productId)
      },
    },
    methods: {
      addToFavorites () {
        return this.$root.addToFavorites(this.productId)
      }
    }
  }
</script>
